/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export class Tab {
  constructor(name: string, disabled: boolean, title: string, route: string) {
    this.name = name;
    this.title = title || name.charAt(0).toUpperCase() + name.slice(1);
    this.disabled = disabled;
    this.loadData = !disabled;
    this.route = route || name;
  }
  name: string;
  title: string;
  loadData: boolean;
  disabled: boolean;
}
